import { OnboardingStep } from '@repo/shared/dtos/organization'
import { GenerationEnum } from '@repo/shared/events/generation'
import { DataStatus } from '@repo/ui/utils'

import { adminStoreActions, storeActions } from '@/store/actions'
import { getCurrentOrganization } from '@/store/helpers'
import { initHandleSocketAction } from '@/store/middlewares/helpers'
import { Action, FakeGenerationEnum, ISocket, MiddlewareType } from '@/store/middlewares/types'
import {
  GenerationPayload,
  UpdateDescriptionPayload,
  UpdateMethodologyPayload,
} from '@/store/thunks/assistant'

export const staticSocketIOMiddleware =
  (UseSocket: ISocket): MiddlewareType =>
  // @ts-expect-error not easy to type correctly
  (store) => {
    return (next) => (action: Action) => {
      const newAction = next(action) // Required to be called at very first place

      const state = store.getState()
      const user = state.user.me
      const organization = getCurrentOrganization(state)
      const caseWorker = state.user.caseWorker

      if (
        !(
          DataStatus.isFulfilled(user) && // isAuthenticated
          DataStatus.isFulfilled(organization) &&
          DataStatus.isFulfilled(caseWorker)
        )
      )
        return newAction

      const handleSocketAction = initHandleSocketAction({ store, UseSocket })

      switch (action.type) {
        case storeActions.assistant.generate.dashboard.beneficiaryProfiles.start.type:
          {
            const { generationId } = action.payload as GenerationPayload
            if (!generationId) return
            if (generationId !== state.assistant.generationId) return

            if (state.beneficiary.all.length > 0) return
            handleSocketAction({
              key: GenerationEnum.GenerateCaseworkerDashboard,
              emitPayload: { generationId },
              endAction: storeActions.assistant.generate.dashboard.beneficiaryProfiles.end,
            })
          }
          break

        case storeActions.assistant.askFor.organization.description.start.type:
          {
            const { generationId } = action.payload as GenerationPayload
            if (!generationId) return
            if (generationId !== state.assistant.generationId) return

            handleSocketAction({
              key: FakeGenerationEnum.AskForDescription,
              emitPayload: {
                generationId,
                organizationStep: organization.onboarding.step,
              },
              endAction: storeActions.assistant.askFor.organization.description.end,
            })
          }
          break

        case storeActions.assistant.askFor.organization.updateDescription.start.type:
          {
            const { generationId, description, traceUrl } =
              action.payload as UpdateDescriptionPayload
            if (!generationId || !description) return
            if (generationId !== state.assistant.generationId) return

            handleSocketAction({
              key: FakeGenerationEnum.AskForUpdatingDescription,
              emitPayload: { generationId, description, traceUrl },
              endAction: storeActions.assistant.askFor.organization.updateDescription.end,
            })
          }
          break

        case storeActions.assistant.askFor.organization.methodology.start.type:
          {
            const { generationId } = action.payload as GenerationPayload
            if (!generationId) return
            if (generationId !== state.assistant.generationId) return

            handleSocketAction({
              key: FakeGenerationEnum.AskForMethodology,
              emitPayload: {
                generationId,
                organizationStep: organization.onboarding.step,
              },
              endAction: storeActions.assistant.askFor.organization.methodology.end,
            })
          }
          break

        case storeActions.assistant.askFor.organization.updateMethodology.start.type:
          {
            const { generationId, methodology, traceUrl } =
              action.payload as UpdateMethodologyPayload
            if (!generationId || !methodology) return
            if (generationId !== state.assistant.generationId) return

            handleSocketAction({
              key: FakeGenerationEnum.AskForUpdatingMethodology,
              emitPayload: { generationId, methodology, traceUrl },
              endAction: storeActions.assistant.askFor.organization.updateMethodology.end,
            })
          }
          break

        case adminStoreActions.onboarding.init.start.type:
          {
            const { generationId } = action.payload as GenerationPayload
            if (!generationId) return
            if (generationId !== state.assistant.generationId) return

            const key =
              organization.onboarding.step === OnboardingStep.ORGANIZATION
                ? FakeGenerationEnum.AskForMethodology
                : organization.onboarding.step === OnboardingStep.METHODOLOGY
                  ? FakeGenerationEnum.AskForResources
                  : organization.onboarding.step === OnboardingStep.SOURCES_PRIVATE
                    ? FakeGenerationEnum.AskForMembers
                    : organization.onboarding.step === OnboardingStep.MEMBERS
                      ? FakeGenerationEnum.AskForCompleteOnboarding
                      : null
            if (key === null) return
            handleSocketAction({
              key,
              emitPayload: {
                generationId,
                organizationStep: organization.onboarding.step,
              },
              endAction: adminStoreActions.onboarding.init.end,
            })
          }
          break
      }

      return newAction
    }
  }
